module.exports = __webpack_public_path__ + "img/building-icon-supply.cb92aea2.png";